import { RawDataPoint } from "./utils/aggregateData";

// Generate test data for a specific date range
const generateTestDataForRange = (
  startDate: Date,
  endDate: Date,
  valueRange: [number, number],
): RawDataPoint[] => {
  const data: RawDataPoint[] = [];
  const [minValue, maxValue] = valueRange;

  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    data.push({
      date: new Date(currentDate),
      value: Math.floor(Math.random() * (maxValue - minValue)) + minValue,
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return data;
};

// Generate current cycle data (Aug 2024 - Jul 2025, ending at today)
const generateCurrentData = (): RawDataPoint[] => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  // Determine if we're in academic year 2024-2025 or 2025-2026
  const isAfterAugust = currentMonth >= 7; // August is month 7 (0-indexed)
  const cycleStartYear = isAfterAugust ? currentYear : currentYear - 1;

  const startDate = new Date(cycleStartYear, 7, 1); // Aug 1 of cycle start year
  const endDate = today;

  return generateTestDataForRange(startDate, endDate, [20, 100]);
};

// Generate comparison data (previous year cycle: Aug 2023 - Jul 2024)
const generateComparisonData = (): RawDataPoint[] => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  // Determine current cycle start year
  const isAfterAugust = currentMonth >= 7;
  const currentCycleStartYear = isAfterAugust ? currentYear : currentYear - 1;

  // Previous cycle is one year before current cycle
  const prevCycleStartYear = currentCycleStartYear - 1;
  const startDate = new Date(prevCycleStartYear, 7, 1); // Aug 1 of previous cycle
  const endDate = new Date(prevCycleStartYear + 1, 6, 31); // Jul 31 of previous cycle end

  return generateTestDataForRange(startDate, endDate, [10, 80]);
};

// Export test data for Components page
export const testCurrentData = generateCurrentData();
export const testComparisonData = generateComparisonData();
